import { ObjectDetailsContentLayout } from 'framework/ViewTypes/contentLayout';
import { RECRUITMENT_POOL_STATUS, RECRUITMENT_POOL_STATUS_LABELS } from '../../constants';
import type { RecruitmentPool, RecruitmentPoolStatus } from '../../types';
import { getRecruitmentPoolHeaderActions } from '../header/headerActions';
import RecruitmentPoolDetailsCard from './RecruitmentPoolDetailsCard';
import RecruitmentPoolTabs from '../tabs/RecruitmentPoolTabs';

type RecruitmentPoolDetailsContentProps = {
  recruitmentPool?: RecruitmentPool;
  loading: boolean;
  error?: Error | null;
  retry?: () => void | Promise<unknown>;
  canUpdate: boolean;
  canSource: boolean;
  onEdit: () => void;
  onTransit: (status: RecruitmentPoolStatus) => void;
  onSourcing: () => void;
};

const RecruitmentPoolDetailsContent = ({
  recruitmentPool,
  loading,
  error,
  retry,
  canUpdate,
  canSource,
  onEdit,
  onTransit,
  onSourcing,
}: RecruitmentPoolDetailsContentProps) => (
  <ObjectDetailsContentLayout
    data={recruitmentPool}
    loading={loading}
    error={error}
    retry={retry}
    notFoundMessage="Recruitment pool not found."
    renderContent={pool => ({
      header: {
        title: pool.name,
        badges: [
          {
            id: 'status',
            label: RECRUITMENT_POOL_STATUS_LABELS[pool.status],
            color: pool.status === RECRUITMENT_POOL_STATUS.CLOSED ? 'default' : 'info',
          },
        ],
        actions: getRecruitmentPoolHeaderActions(pool, canUpdate, canSource, onEdit, onTransit, onSourcing),
      },
      leftSide: <RecruitmentPoolDetailsCard recruitmentPool={pool} />,
      rightSide: <RecruitmentPoolTabs />,
    })}
  />
);

export default RecruitmentPoolDetailsContent;
